/** English message catalogue (stub — will be expanded). */
export const messages = {
  "common.home": "Home",
  "common.docs": "Documents",
  "common.search": "Search",
  "common.chat": "Chat",
  "common.notebooks": "Notebooks",
  "common.upload": "Import",
  "common.settings": "Settings",
  "common.create": "Create",
  "common.cancel": "Cancel",
  "common.save": "Save",
  "common.delete": "Delete",
  "common.close": "Close",
  "common.confirm": "Confirm",
  "common.loading": "Loading…",
  "common.error": "Something went wrong",
  "common.retry": "Retry",
  "common.search_placeholder": "Search docs, sections, actions…",
  "common.empty": "No data",
  "shell.scope.project": "Project",
  "shell.scope.all": "All",
  "shell.theme.light": "Light",
  "shell.theme.dark": "Dark",
  "shell.theme.system": "System",
  "shell.toggle_sidebar": "Toggle sidebar",
  "shell.toggle_ai": "Toggle AI panel",
  "shell.toggle_chat": "Toggle chat",
  "shell.notifications": "Notifications",
  "docs.title": "Documents",
  "docs.empty": "No documents yet. Import your first one.",
  "search.placeholder": "Ask anything about your documentation",
  "search.empty": "No results found. Try removing filters.",
  "chat.welcome": "Start a conversation",
  "chat.input_placeholder": "Your question… ⌘↵ to send",
  "notebook.add_item": "Add item",
  "notebook.empty": "This notebook is empty",
  "upload.dropzone": "Drop files here or click",
  "upload.accepts": "Accepts .md .docx .pdf .html .csv .xlsx (max 50MB)",
} as const;
export type MessageKey = keyof typeof messages;
